// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const ProductBadgeWaterproof: React.FC<{
    size?: number;
    color1?: string;
    color2?: string;
    color3?: string;
    className?: string;
}> = ({ size = 18, color1 = "#fff", color2 = "#ccc", color3 = "#415465", className }) => (
    <svg className={className} focusable="false" viewBox="0 0 18 18" width={size} height={size}>
        <g fill="none" fillRule="evenodd">
            <rect width="18" height="18" fill={color1} rx="9" />
            <path
                fill={color2}
                fillRule="nonzero"
                d="M9 0a9 9 0 1 1 0 18A9 9 0 0 1 9 0m0 .5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17"
            />
            <path
                fill={color3}
                fillRule="nonzero"
                d="M9 12.656c.651 0 1.244-.256 1.686-.678l.653.527A3.26 3.26 0 0 1 9 13.5c-1.822 0-3.3-1.512-3.3-3.375 0-.487.206-1.106.512-1.75l.665.535q-.03.072-.061.141c-.205.485-.293.847-.293 1.074 0 1.398 1.109 2.531 2.475 2.531zm3.183-1.64 2.159 1.73c.179.144.211.41.07.592a.407.407 0 0 1-.579.072L3.658 5.254a.43.43 0 0 1-.07-.592c.14-.183.4-.216.579-.072l2.87 2.3a28 28 0 0 1 1.528-2.184.52.52 0 0 1 .42-.206h.03a.53.53 0 0 1 .422.206c.625.808 2.863 3.816 2.863 5.42 0 .307-.041.607-.117.89m-.727-.582q.018-.15.019-.309c0-.228-.088-.589-.292-1.074-.198-.468-.475-.98-.782-1.489A26 26 0 0 0 9 5.506a27 27 0 0 0-1.311 1.907zm-4.106-.45a.42.42 0 0 1 .345-.416l.48.385.002.03c0 .543.431.984.962.984.229 0 .413.188.413.422a.416.416 0 0 1-.413.422c-.986 0-1.787-.82-1.787-1.828z"
            />
        </g>
    </svg>
);

export default React.memo(ProductBadgeWaterproof);
